import React, { useState } from "react";
import styles from "./Faq.module.css";
import "./display.css";

const FaqQuestion = (props) => {
  console.log(props);
  const [show, setShow] = useState(false);
  const [plus, setPlus] = useState(true);
  const { questionName, answer } = props.name;
  const showAnswer = () => {
    setShow(!show);
    setPlus(!plus);
  };
  return (
    <div className={styles.box98}>
      <div
        onClick={showAnswer}
        className={`d-flex  ${styles.question}`}
        style={{ width: "820px" }}
      >
        <h6 className={styles.questionName}>{questionName}</h6>
        {plus && (
          <div className={styles.plus}>
            <div className={styles.plus_icon}></div>
          </div>
        )}
        {!plus && (
          <div className={styles.minus}>
            <div className={styles.minus_icon}></div>
          </div>
        )}
      </div>
      {show && (
        <h6
          className={!show ? "answer" : "answer active"}
          style={{ textAlign: "justify", color: "#000000c7" }}
        >
          {typeof answer === "string" &&
            answer.length > 0 &&
            answer.split("\n").map((ansItem, i) => {
              return <p key={i}>{ansItem}</p>;
            })}
        </h6>
      )}
    </div>
  );
};

export default FaqQuestion;
